import React from 'react';
import './_toggleButton.scss'

const ToggleButton = ({ toggleButton, toggle, classNames }) => (
	<button
		type="button"
		className={classNames}
		data-toggle="button"
		aria-pressed="false"
		autoComplete="off"
		onClick={() => toggleButton()}
	>
		<div className="handle" />
	</button>
);

export default ToggleButton;
